import React, { useEffect } from "react"
import { Box, Paper, Typography } from "@mui/material"
import { ProductionVsBudgetTable } from "../../components/Table/Provider_Production Summery Table/Production_vs_Budget Table"
import ProviderProductionSummeryHeader from "../../components/Headers/ProviderProductionSummeryHeader"
import MetricAPI from "../../../api/metric"
import { getTokenLocal } from "../../../helper/utils"
import { useDispatch } from "react-redux"
import { useResponseHandle } from "../../hooks"
import { setLoading, setOpenSidebar } from "../../redux/slices/appSlice"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { setPracticeSummaryData } from "../../redux/slices/providerProductionSummarySlice"
import ProviderProductionSummeryAPI from "../../../api/providerProductionSummery"
import { colors } from "../../../styles/commonStyles"
import { ProductionVsGoalTable } from "../../components/Table/Provider_Production Summery Table/ProductionVsGoalTable"
import { NavigationAssistant } from "../Huddle/Atom"
import { TableWrapperPaper } from "./Atom"
import {
  setMaevaGroups,
  setMaevaPractices,
  setMaevaRegions,
} from "../../redux/slices/metricSlice"
const metricAPI = new MetricAPI()
const providerProductionSummeryAPI = new ProviderProductionSummeryAPI()

const ProviderProductionSummary = () => {
  const token: any = getTokenLocal()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const selectedSummaryGroupData = useSelector((state: any) => {
    return state.metric.maevaSelectedGroupsNoAll?.[0]
  })
  const summarySelectedRegion = useSelector((state: any) => {
    return state.metric.maevaSelectedRegionsNoAll?.[0]
  })
  const summarySelectedPractice = useSelector((state: any) => {
    return state.metric.maevaSelectedPracticesNoAll?.[0]
  })

  dispatch(setOpenSidebar(false))

  const fetchGroupList = async () => {
    const groups: Array<Object> = []

    const response = await metricAPI.getMetricGroupsBoarded(token)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        response?.data?.data?.forEach((g: any) => {
          groups.push({ ...g, label: g.group_name })
        })
        dispatch(setLoading(false))
        dispatch(setMaevaGroups(groups))
      }
    } else {
      navigate("/auth")
    }

    return result
  }
  const fetchRegionList = async () => {
    const regions: Array<Object> = []
    dispatch(setLoading(true))
    const response = await metricAPI.getMetricRegionsByGroups(token, [
      selectedSummaryGroupData?.group_sk,
    ])

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        response?.data?.data?.regions?.forEach((region: any) => {
          regions.push({ label: region, region: region.toLowerCase() })
        })

        dispatch(setMaevaRegions(regions))
        dispatch(setLoading(false))
      }
    } else {
      navigate("/auth")
    }

    return result
  }

  const fetchPracticeList = async () => {
    const practice: Array<Object> = []
    dispatch(setLoading(true))
    const response = await metricAPI.getMetricPracticesByRegions(
      token,
      [selectedSummaryGroupData?.group_sk],
      [summarySelectedRegion?.region],
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        response?.data?.data?.map((ele: any) => {
          practice.push({ ...ele, label: ele.name })
        })

        dispatch(setMaevaPractices(practice))
        dispatch(setLoading(false))
      }
    } else {
      navigate("/auth")
    }

    return result
  }
  const fetchSummary = async () => {
    dispatch(setLoading(true))
    const response = await providerProductionSummeryAPI.getSummaryByPratice(
      token,
      summarySelectedPractice?.practice_sk,
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        dispatch(setPracticeSummaryData(response?.data?.data))
        dispatch(setLoading(false))
      }
    } else {
      navigate("/auth")
    }

    return result
  }

  useEffect(() => {
    fetchGroupList()
  }, [])
  useEffect(() => {
    if (selectedSummaryGroupData) {
      fetchRegionList()
    }
  }, [selectedSummaryGroupData])

  useEffect(() => {
    if (summarySelectedRegion) {
      fetchPracticeList()
    }
  }, [summarySelectedRegion])

  useEffect(() => {
    if (summarySelectedPractice) {
      fetchSummary()
    }
  }, [summarySelectedPractice])

  const navigationData = React.useMemo(
    () => [
      {
        label: "Select a group to proceed",
        value: selectedSummaryGroupData ? true : false,
      },
      {
        label: "Select a region to proceed",
        value: summarySelectedRegion ? true : false,
      },
      {
        label: "Select a office to proceed",
        value: summarySelectedPractice ? true : false,
      },
    ],
    [selectedSummaryGroupData, summarySelectedRegion, summarySelectedPractice],
  )

  return (
    <Box
      sx={{
        display: "flex",
        flexGrow: 1,
        flexDirection: "column",
        height: "100%",
        background: colors.background,
      }}
    >
      <ProviderProductionSummeryHeader name="Provider/ Production Summary" />
      {summarySelectedPractice ? (
        <>
          <TableWrapperPaper sx={{ mb: "10px", height: "30vh" }}>
            <ProductionVsBudgetTable />
          </TableWrapperPaper>

          <TableWrapperPaper
            sx={{
              mb: "10px",
              overflowY: "scroll",
              height: "47vh",
            }}
          >
            <Paper
              elevation={5}
              sx={{
                borderRadius: 0,
                position: "sticky",
                top: 0,
                zIndex: "2",
                backgroundColor: "#fff",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                  my: "9px",
                  pl: "15px",
                  fontSize: "14px",
                }}
              >
                Production vs Goal- Next 10 days
              </Typography>
            </Paper>
            <Box sx={{ zIndex: "1" }}>
              <ProductionVsGoalTable />
            </Box>
          </TableWrapperPaper>
        </>
      ) : (
        <NavigationAssistant data={navigationData} />
      )}
    </Box>
  )
}

export default ProviderProductionSummary
